import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AccordionGeneric.css';
import React from 'react';
import { get } from '../../utils';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import IconPlus from '../atoms/Icons/IconPlus';
import IconMinus from '../atoms/Icons/IconMinus';
import IconChevronRight from '../atoms/Icons/IconChevronRight';
import IconChevronLeft from '../atoms/Icons/IconChevronLeft';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import { ReactComponent as ChevronDown } from '../../resources/icons/IconChevronDown.svg';
export var AccordionGeneric = function AccordionGeneric(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var isFirstExpanded = Boolean(get(fields, 'data.item.isFirstExpanded.jss.value'));
  var hasItems = Boolean(get(fields, 'data.item.children.length'));
  var items = hasItems ? fields.data.item.children : [];
  var filteredItems = items.filter(function (i) {
    return get(i, 'title.jss.value') && get(i, 'children.length');
  });
  var defaultStartItemId = items && items.length > 0 ? items[0].id : '0';
  var _React$useState = React.useState(defaultStartItemId),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeItemId = _React$useState2[0],
    setActiveItemId = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    activeSubItemsIds = _React$useState4[0],
    setActiveSubItemsIds = _React$useState4[1];
  var activeItem = filteredItems.find(function (i) {
    return i.id === activeItemId;
  });
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  React.useEffect(function () {
    if (!filteredItems.length) return;
    setActiveItemId(filteredItems[0].id);
    if (isFirstExpanded && activeItem) {
      var _activeItem$children = _slicedToArray(activeItem.children, 1),
        subItem = _activeItem$children[0];
      setActiveSubItemsIds([subItem.id]);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleAccordionItemClick = React.useCallback(function (e, id) {
    e.preventDefault();
    if (id !== activeItemId) {
      setActiveSubItemsIds([]);
      setActiveItemId(id);
    } else {
      //close opened faq only on mobile
      if (window.matchMedia('(max-width: 991px)').matches) setActiveItemId('');
    }
  }, [activeItemId]);
  var handleAccordionSubItemClick = React.useCallback(function (e, id, isActive) {
    e.preventDefault();
    var nextActiveItemsIds = isActive ? activeSubItemsIds.filter(function (i) {
      return i !== id;
    }) : [].concat(_toConsumableArray(activeSubItemsIds), [id]);
    setActiveSubItemsIds(nextActiveItemsIds);
  }, [activeSubItemsIds]);
  if (!fields) {
    console.info('AccordionGeneric component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[AccordionGeneric component is empty: please provide data source]");
    }
    return null;
  }
  var renderLeftPanel = function renderLeftPanel() {
    return /*#__PURE__*/React.createElement("div", {
      className: "desktop-only accordion-left-panel"
    }, filteredItems.map(function (item) {
      return /*#__PURE__*/React.createElement("h4", {
        key: item.id,
        className: "h4 accordion__heading ".concat(item.id === activeItemId ? 'accordion__heading--active' : ''),
        "data-cy": "accordion-generic-category-title",
        onClick: function onClick(e) {
          handleAccordionItemClick(e, item.id);
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['categoryAnalytics'], params), "".concat(item.name));
        }
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "a",
        className: "accordion__anchor",
        href: "/",
        field: item.title.jss
      }), /*#__PURE__*/React.createElement("span", {
        className: "accordion__icon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "accordion__icon-desk"
      }, rtl ? /*#__PURE__*/React.createElement(IconChevronLeft, null) : /*#__PURE__*/React.createElement(IconChevronRight, null)));
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: "\n          {\n            \"@context\": \"https://schema.org\",\n            \"@type\": \"FAQPage\",\n            \"mainEntity\": [\n\n            ".concat(items.map(function (item) {
        return get(item, 'children', []).map(function (faq) {
          return "{\n                  \"@type\": \"Question\",\n                  \"name\": ".concat(JSON.stringify(get(faq, 'title.jss.value')), ",\n                  \"acceptedAnswer\": {\n                    \"@type\": \"Answer\",\n                    \"text\": ").concat(JSON.stringify(get(faq, 'description.jss.value')), "\n                  }\n                }");
        });
      }), "]\n          }")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "section-generic",
    "data-cy": "accordion-generic"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 accordion-main-heading",
    field: fields.data.item.title.jss,
    "data-cy": "accordion-generic-title"
  }), /*#__PURE__*/React.createElement("div", {
    className: "accordion accordion--generic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row accordion__row"
  }, renderLeftPanel(), /*#__PURE__*/React.createElement("div", {
    className: "accordion-right-panel"
  }, filteredItems.map(function (item) {
    var isActive = item.id === activeItemId;
    var activeParentItem = filteredItems.find(function (item) {
      return item.id === activeItemId;
    });
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "accordion__list ".concat(isActive ? 'accordion__list--active' : '')
    }, /*#__PURE__*/React.createElement("p", {
      className: "accordion__heading body-medium mobile-only",
      onClick: function onClick(e) {
        handleAccordionItemClick(e, item.id);
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['questionAnalytics'], params), "".concat(item.name, ": ").concat(isActive ? 'Collapse' : 'Expand'));
      }
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      field: item.title.jss
    }), /*#__PURE__*/React.createElement("span", {
      className: "accordion__icon"
    }, /*#__PURE__*/React.createElement(ChevronDown, null)), /*#__PURE__*/React.createElement("span", {
      className: "accordion__icon-desk"
    })), isActive && /*#__PURE__*/React.createElement("div", {
      className: "accordion__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cta-group"
    }, activeItem.description.jss.value && /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "label-small widget-description",
      field: activeItem.description.jss
    }), activeItem.children.map(function (subItem) {
      var isSubItemActive = activeSubItemsIds.includes(subItem.id);
      var shouldBeRendered = subItem.title.jss.value || subItem.description.jss.value ? true : false;
      if (!shouldBeRendered) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        key: subItem.id,
        className: "cta-overlay__link ".concat(isSubItemActive ? "cta-overlay__link--active" : "")
      }, /*#__PURE__*/React.createElement("div", {
        className: "cta-overlay__anchor-wrapper",
        onClick: function onClick(e) {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['categoryQuestionAnalytics'], params), "".concat(activeParentItem ? activeParentItem.name : '', ": ").concat(subItem.name, ": ").concat(isSubItemActive ? 'Collapse' : 'Expand'));
          handleAccordionSubItemClick(e, subItem.id, isSubItemActive);
        }
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "a",
        className: "cta-overlay__anchor",
        href: "/",
        field: subItem.title.jss,
        "data-cy": "accordion-generic-anchor"
      }), /*#__PURE__*/React.createElement("span", {
        className: "accordion__icon-desktop"
      }, isSubItemActive ? /*#__PURE__*/React.createElement(IconMinus, null) : /*#__PURE__*/React.createElement(IconPlus, null))), (isSubItemActive || pageEditing) && /*#__PURE__*/React.createElement("div", {
        className: "accordion-overlay",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "accordion-overlay__content",
        "data-cy": "accordion-generic-item-content"
      }, /*#__PURE__*/React.createElement(RichText, {
        tag: "p",
        className: "body-small",
        field: subItem.description.jss
      }))));
    }))));
  }))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1g6k3ry";
var ltrStyles = "lt55cmv";
var rtlStyles = "rgk56uj";
export default AccordionGeneric;